import React from 'react';
import PropTypes from 'prop-types';
import { BrowserRouter as Router } from 'react-router-dom';
import Routes from '../../routes';
import css from './index.scss';
import Toast from '../../components/toast';

const RootContainer = (props) => {
    const container = (
        <div className={css.rootContainer}>
            <Router basename={props.basename} >
                <Routes />
            </Router>
            <Toast />
        </div>);
    return container;
};

RootContainer.propTypes = {
    basename: PropTypes.string
};

export default RootContainer;



// WEBPACK FOOTER //
// ./app/components/root-container/index.js